<script setup>
const {
  name = "",
  subName,
  imageSrc,
  size = "md",
  className,
} = defineProps({
  name: String,
  subName: String,
  imageSrc: String,
  size: "sm" | "md" | "lg",
  className: String,
});

const imgClass = computed(() => ({
  "w-8 h-8 min-h-8 min-w-8": size === "sm",
  "w-11 h-11 min-h-11 min-w-11": size === "md",
  "w-16 h-16 min-h-16 min-w-16": size === "lg",
}));

const textClass = computed(() => ({
  "text-sm": size === "sm",
  "text-base": size === "md",
  "text-lg": size === "lg",
  className,
}));
</script>

<template>
  <div class="flex items-center gap-3">
    <Avatar
      v-if="imageSrc"
      size="normal"
      shape="circle"
      :class="imgClass"
      :image="imageSrc"
    />
    <Avatar
      v-else
      :label="name?.at(0)"
      size="normal"
      shape="circle"
      :class="imgClass"
    />
    <div class="flex flex-col justify-center">
      <p :class="textClass">{{ name }}</p>
      <p class="text-sm text-muted">{{ subName }}</p>
    </div>
  </div>
</template>
